import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../ServicePage.css';

function Docker() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Docker & Containerizzazione</h1>
                    <p className="service-description">
                        Soluzioni complete di containerizzazione con Docker per deployment 
                        scalabili, portabili e ottimizzati delle tue applicazioni.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Cos'è Docker?</h2>
                                <p className="section-description">
                                    Docker è una piattaforma di containerizzazione che permette di creare, distribuire 
                                    e gestire applicazioni in ambienti isolati e portatili chiamati container. 
                                    Garantisce che le applicazioni funzionino in modo consistente in qualsiasi ambiente.
                                </p>
                                
                                <div className="docker-features">
                                    <Row>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-box text-primary"></i>
                                                <strong>Containerizzazione</strong>
                                                <p>Isolamento completo delle applicazioni con le loro dipendenze</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-rocket text-primary"></i>
                                                <strong>Deployment Rapido</strong>
                                                <p>Avvio istantaneo e scalabilità automatica delle applicazioni</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-sync text-primary"></i>
                                                <strong>Portabilità</strong>
                                                <p>Stesso comportamento in sviluppo, test e produzione</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-shield-alt text-primary"></i>
                                                <strong>Sicurezza</strong>
                                                <p>Isolamento dei processi e gestione sicura delle risorse</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">I Nostri Servizi Docker</h2>
                                
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-cube text-primary"></i>
                                            </div>
                                            <h4>Containerizzazione Applicazioni</h4>
                                            <p>
                                                Migrazione di applicazioni esistenti in container Docker ottimizzati
                                                per performance, sicurezza e scalabilità.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-cogs text-primary"></i>
                                            </div>
                                            <h4>Docker Compose</h4>
                                            <p>
                                                Setup di ambienti multi-container con Docker Compose per 
                                                orchestrazione semplificata e gestione dei servizi.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-server text-primary"></i>
                                            </div>
                                            <h4>Registry e CI/CD</h4>
                                            <p>
                                                Implementazione di Docker Registry privati e pipeline CI/CD 
                                                automatizzate per deployment continuo.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-chart-line text-primary"></i>
                                            </div>
                                            <h4>Monitoring e Ottimizzazione</h4>
                                            <p>
                                                Monitoring avanzato dei container e ottimizzazione delle 
                                                performance per massimizzare l'efficienza delle risorse.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Perché Scegliere i Nostri Servizi Docker?</h2>
                                
                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-certificate text-primary"></i>
                                            </div>
                                            <h5>Esperienza Comprovata</h5>
                                            <p>Anni di esperienza nella containerizzazione e nel deployment Docker</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-tachometer-alt text-primary"></i>
                                            </div>
                                            <h5>Performance Ottimali</h5>
                                            <p>Ottimizzazione avanzata per ridurre tempi di avvio e consumo risorse</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-headset text-primary"></i>
                                            </div>
                                            <h5>Supporto Completo</h5>
                                            <p>Assistenza tecnica dedicata e formazione del team</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Pronto per la Containerizzazione?</h3>
                                <p className="mb-4">
                                    Contattaci per una consulenza gratuita e scopri come Docker può 
                                    ottimizzare i tuoi deployment e migliorare la scalabilità delle tue applicazioni.
                                </p>
                                <a href="#contact" className="btn btn-primary btn-lg">
                                    Richiedi Consulenza Gratuita
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Docker;